import { Injectable } from '@angular/core';
import mixpanel from 'mixpanel-browser';
import { environment } from '../../../environments/environment.deploy';

@Injectable({
  providedIn: 'root'
})
export class MixpanelService {

  private enabled = false;
  private initialized = false;

  constructor() {
    try {
      this.enabled = environment.mixpanelEnabled === true;

      if (this.enabled && environment.mixpanelToken) {
        mixpanel.init(environment.mixpanelToken, {
          autocapture: true
        });
        this.initialized = true;
      }
    } catch (error) {
      console.error('Erro ao inicializar Mixpanel', error);
      this.enabled = false;
      this.initialized = false;
    }
  }


  track(event: string, properties?: any): void {
    if (!this.enabled || !this.initialized) {
      return;
    }

    mixpanel.track(event, properties);
  }

  identify(userId: string): void {
    if (!this.enabled || !this.initialized) {
      return;
    }

    mixpanel.identify(userId);
  }

  setUserProperties(properties: any): void {
    if (!this.enabled || !this.initialized) {
      return;
    }

    mixpanel.people.set(properties);
  }

}
